import { orchestrator } from 'satcheljs';
import { NewReportRoute } from '../../../../Routes';
import { onCurrentRouteChanged } from '../actions';
import { onChangeReportId } from '../actions/onChangeReportId';
import { RouteName } from '../store/store';

orchestrator(onChangeReportId, (msg) => {
  try {
    const currentUrl = new URL(window.location.href);
    const pathSegments = currentUrl.pathname.split('/').filter((segment) => segment.length > 0);

    const routeIndex = pathSegments.findIndex((segment) => segment === RouteName.details || segment === RouteName.overview);

    if (routeIndex === -1) {
      console.warn('Could not find route segment in path:', currentUrl.pathname);
      return;
    }

    const basePath = pathSegments.slice(0, routeIndex);

    const newRoute = msg.reportId ? RouteName.details : RouteName.overview;
    const newPathSegments = [...basePath, newRoute];

    if (msg.reportId) {
      newPathSegments.push(msg.reportId.toLowerCase());
    }

    const newPath = '/' + newPathSegments.join('/');
    const newUrl = newPath + currentUrl.search;

    onCurrentRouteChanged(newRoute);
    msg.history.push(newUrl);
  } catch (error) {
    const fallbackPath = msg.reportId ? `/${NewReportRoute}/details/${msg.reportId.toLowerCase()}` : `/${NewReportRoute}/overview`;
    msg.history.push(fallbackPath);
    console.error('Error in ChangeReportId orchestrator:', error);
  }
});
